import URI from "urijs"

export const setQueryParameter = (url, key, value) => {
  const newUrl = new URI(url)
  newUrl.addSearch(key, value)
  return newUrl.toString()
}
